import store from '../store';
import {get, merge} from "../helpers";

class ConfigurationService {
  /**
   * First is the name of the view and second is progress bar step "{GeneralInfoView: 1}"
   */
  paths = {
    default: {
      male: [{GeneralInfoView: 1}, {TummyView: 2}, {ChestView: 3}, {WaistFitView: 3}, {AgeAndFitView: 4}, {Brands: 5}, {ResultView: 6}],
      female: [{GeneralInfoView: 1}, {TummyView: 2}, {HipsView: 2}, {BraView: 3}, {RiseView: 3}, {AgeAndFitView: 4}, {Brands: 5}, {ResultView: 6}],
    },
    hoodies: {
      male: [{GeneralInfoView: 1}, {TummyView: 2}, {ChestView: 3}, {AgeAndFitView: 4}, {Brands: 5}, {SendSelectionsView: 6}, {ResultView: 6}],
      female: [{GeneralInfoView: 1}, {TummyView: 2}, {AgeAndFitView: 3}, {Brands: 4}, {SendSelectionsView: 5}, {ResultView: 5}],
    },
    sweatpants: {
      male: [{GeneralInfoView: 1}, {TummyView: 2}, {WaistFitView: 3}, {AgeAndFitView: 4}, {Brands: 5}, {SendSelectionsView: 6}, {ResultView: 6}],
      female: [{GeneralInfoView: 1}, {TummyView: 2}, {HipsView: 3}, {RiseView: 4}, {AgeAndFitView: 5}, {Brands: 6}, {SendSelectionsView: 7}, {ResultView: 7}],
    },
    bomber_jacket: {
      male: [{GeneralInfoView: 1}, {TummyView: 2}, {ChestView: 3}, {AgeAndFitView: 4}, {Brands: 5}, {SendSelectionsView: 6}, {ResultView: 6}],
      female: [{GeneralInfoView: 1}, {TummyView: 2}, {AgeAndFitView: 3}, {Brands: 5}, {SendSelectionsView: 6}, {ResultView: 6}],
    },
    jersey: {
      male: [{GeneralInfoView: 1}, {TummyView: 2}, {ChestView: 3}, {AgeAndFitView: 4}, {Brands: 5}, {SendSelectionsView: 6}, {ResultView: 6}],
      female: [{GeneralInfoView: 1}, {TummyView: 2}, {AgeAndFitView: 3}, {Brands: 5}, {SendSelectionsView: 6}, {ResultView: 6}],
    },
    't-shirt': {
      male: [{GeneralInfoView: 1}, {TummyView: 2}, {ChestView: 3}, {AgeAndFitView: 4}, {Brands: 5}, {SendSelectionsView: 6}, {ResultView: 6}],
      female: [{GeneralInfoView: 1}, {TummyView: 2}, {AgeAndFitView: 3}, {Brands: 5}, {SendSelectionsView: 6}, {ResultView: 6}],
    },
  };

  currentType = 'hoodies';

  options = {
    shop: null,
    renderer: {
      container: {
        id: 'sizing-app',
      },
    },
    elements: {
      findYourSize: {
        appendAfter: '.page-product form',
      },
    },
    options: {
      bodyFixed: true,
    },
    content: {
      thankYouMessage: 'Data was submitted successfully',
      confirmationMessage: 'Thank you for your submittion',
      noRecommendationHtmlMessage: '<p>There are no recommendations currently.<p><p>Please check the sizing chart <a href="#">here</a>.</p>',
    },
    events: {
      sizingAppWasOpened: () => {
        console.log('event: sizingAppWasOpened');
      },
      sizingAppWasClosed: () => {
        console.log('event: sizingAppWasClosed');
      },
      wizardStepWasChanged: (view, step) => {
        console.log('event: wizardStepWasChanged', {view, step});
      },
      wizardWasCompleted: () => { // keeping this for backward compatibility
        console.log('event: wizardWasCompleted');
      },
      recommendationGiven: () => {
        console.log('event: recommendationGiven');
      },
      noRecommendationFound: () => {
        console.log('event: noRecommendationFound');
      },
    },
  };

  /**
   * window.sizingAppConfig can be present on page where we are embedding the app
   * if it is - merge it into our options
   */
  init() {
    if (!window.sizingAppConfig) return;

    // merge sizingAppConfig to options
    merge(this.options, window.sizingAppConfig || {});

    const type = window.sizingAppConfig.productType;
    if (type && this.paths[type]) {
      this.currentType = type.toLowerCase();
    }
  }

  option(path, defaultValue = null) {
    return get(this.options, path, defaultValue);
  }

  getAvailableSizes() {
    const validSizes = [
      '3XS', '2XS', 'XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '2XL', '3XL', '4XL',
      '3xs', '2xs', 'xxxs', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', '2xl', '3xl', '4xl',
    ];

    return this.option('availableSizes', [])
      .filter(i => validSizes.includes(i));
  }

  getSizeType() {
    const typesThatUseNumberSizes = [];

    return typesThatUseNumberSizes.includes(this.currentType)
      ? 'number'
      : 'letter';
  }

  getViewsPath() {
    const gender = store.getters['userSelections/getGenderHumanReadable'];

    return this.paths[this.currentType][gender];
  }

  getViewName(viewObject) {
    return Object.keys(viewObject)[0];
  }

  getViewStep(viewObject) {
    return Object.values(viewObject)[0];
  }

  getCurrentType() {
    return this.currentType;
  }

  getEvent(eventName) {
    return get(this.options, `events.${eventName}`);
  }
}

export default new ConfigurationService();
